// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"f6096e1e","223":"b6bc144b","277":"8506fa8d","278":"96c6a1e6","453":"542b65e3","766":"b7c0b073","895":"2d4b9712"}[chunkId] + ".chunk.js";
};